module.exports = __webpack_public_path__ + "static/media/statWhite.f42b19b8.svg";